<template>
    <div class="container-fluid">
        <div class="loading-state" v-if="loading">
            <ProgressSpinner fill="transparent" aria-label="Loading" />
        </div>
        <div class="row mb-5">
            <div class="col-12">
                <ul id="prePrintTab" class="nav nav-tabs" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button id="first-prePrint" class="nav-link active" data-bs-toggle="tab"
                            data-bs-target="#firstprePrint" type="button" role="tab" aria-controls="firstprePrint"
                            aria-selected="true">
                            {{ $t("content.pawnticketbook") }}
                        </button>
                    </li>

                    <li class="nav-item" role="presentation">
                        <button id="second-prePrint" class="nav-link" data-bs-toggle="tab"
                            data-bs-target="#secondprePrint" type="button" role="tab" aria-controls="secondprePrint"
                            aria-selected="false">
                            {{ $t("content.pawnshoplicense") }}
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button id="third-prePrint" class="nav-link" data-bs-toggle="tab"
                            data-bs-target="#thirdprePrint" type="button" role="tab" aria-controls="thirdprePrint"
                            aria-selected="false">
                            {{ $t("content.currentticketbook") }}
                        </button>
                    </li>
                </ul>

                <div id="prePrintTabContent" class="tab-content">
                    <div id="firstprePrint" class="tab-pane fade show active" role="tabpanel"
                        aria-labelledby="first-prePrint">
                        <div class="card mt-2">
                            <div class="card-header mb-0">
                                <div class="row no-gutters">
                                    <div class="col-12 d-flex justify-content-between align-items-center">
                                        <h5>{{ $t("content.pawnticketbook") }}</h5>
                                        <div>
                                            <material-button color="primary" class="float-lg-start float-sm-end mb-0"
                                                @click="showTkModal('add', null)">
                                                <i class="material-icons material-symbols-outlined">add</i>
                                                {{ btnAddBook }}
                                            </material-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body pt-0">
                                <div class="row">
                                    <div class="col-lg-3">
                                        <label class="form-label ms-0">{{ $t("content.shop_name") }}</label>
                                        <select v-model="shoptk_search" class="form-select"
                                            :disabled="shopList.length === 0">
                                            <option value="" disabled selected>{{ $t('content.select') }}</option>
                                            <option v-for="(item, index) in shopList" :value="item.uid" :key="index">
                                                {{ item.nameTh }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-lg-2">
                                        <label class="form-label ms-0">{{ $t("content.status") }}</label>
                                        <select class="form-select" v-model="statustk_search">
                                            <option value="" selected>{{ $t("content.optall") }}</option>
                                            <option value="APPROVE" selected>APPROVE</option>
                                            <option value="DRAFT" selected>DRAFT</option>
                                        </select>
                                    </div>

                                    <div class="col-lg-2">
                                        <label class="form-label ms-0 png"></label>
                                        <material-button color="primary" class="float-lg-start float-sm-end mb-3"
                                            :disabled="shoptk_search === ''" @click="loadDataTk">
                                            <i class="material-icons material-symbols-outlined">search</i>
                                            {{ btnSearch }}
                                        </material-button>
                                    </div>
                                </div>
                                <hr />
                                <div class="row">
                                    <div class="table-responsive">
                                        <table class="table table-flush">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th class="text-center">#</th>
                                                    <th class="text-center">{{ $t("content.dantdo") }}</th>
                                                    <th class="text-center">{{ $t("content.shop_name") }}</th>
                                                    <th class="text-center">{{ $t("content.bookstart") }}</th>
                                                    <th class="text-center">{{ $t("content.bookend") }}</th>
                                                    <th class="text-center">{{ $t("content.bookamount") }}</th>
                                                    <th class="text-center"></th>
                                                    <th class="text-center">{{ $t("content.appvdate") }}</th>
                                                    <th class="text-center">{{ $t("content.attach") }}</th>
                                                    <th width="100px">{{ $t("content.act") }}</th>
                                                </tr>
                                            </thead>
                                            <tbody v-for="(i, item1) in listtk" :key="item1" :data-group-index="item1">
                                                <tr class="group-id-ticket"
                                                    :class="i.txStatus === 'APPROVE' ? '' : 'bg-working'">
                                                    <td class="text-sm font-weight-normal" colspan="10">
                                                        <div class="group-tickect" style="padding: 0.5rem !important">
                                                            <h6 class="mb-0">
                                                                <b>#{{ item1 + 1 }} {{ t("content.shop_name_req") }} :
                                                                    {{
                                                                        i.fullname }} ({{ t("content.bookyear") }} - {{
                                                                        i.validYear }} )
                                                                </b>
                                                            </h6>
                                                        </div>
                                                    </td>

                                                </tr>
                                                <tr v-for="(row, set1) in i.formDetails" :key="set1">
                                                    <td class="text-sm font-weight-normal">
                                                        {{ set1 + 1 }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ format_date(i.requestDate) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal text-center">
                                                        {{ row.fullname }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal text-center">
                                                        {{ row.startVolNo }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal text-center">
                                                        {{ row.endVolNo }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal text-center">
                                                        {{ formatNumberString(Number(row.endVolNo)
                                                            - Number(row.startVolNo) + 1) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal text-center">
                                                        <material-button color="warning" variant="outline"
                                                            v-if="i.txStatus === 'APPROVE'" class="rounded-circle me-1"
                                                            data-bs-toggle="tooltip" data-bs-placement="top"
                                                            :title="btnPcover" @click="getCoverDetail(i, row, 'cover')">
                                                            <i
                                                                class="material-icons material-symbols-outlined">text_snippet</i>
                                                        </material-button>
                                                        <material-button color="primary" variant="outline"
                                                            v-if="i.txStatus === 'APPROVE'" class="rounded-circle me-1"
                                                            data-bs-toggle="tooltip" data-bs-placement="top"
                                                            :title="btnPBlank" @click="getCoverDetail(i, row, 'blank')">
                                                            <i
                                                                class="material-icons material-symbols-outlined">article</i>
                                                        </material-button>
                                                    </td>
                                                    <td v-if="set1 === 0" :rowspan="i.formDetails.length"
                                                        class="text-sm font-weight-normal text-center">
                                                        {{ format_date(i.approveDate) }}
                                                    </td>
                                                    <td v-if="set1 === 0" :rowspan="i.formDetails.length"
                                                        class="text-sm font-weight-normal text-center">
                                                        <material-button color="info" variant="outline"
                                                            class="rounded-circle" data-bs-toggle="tooltip"
                                                            data-bs-placement="top" :title="btnPreview"
                                                            v-if="i.refDocUid !== '0' && i.refDocUid !== null"
                                                            @click="getFileRef(i)">
                                                            <i
                                                                class="material-icons material-symbols-outlined">attach_file</i>
                                                        </material-button>
                                                        <material-button color="primary" data-bs-toggle="modal"
                                                            data-bs-target="#attachmentsModal" v-show="false"
                                                            id="attachmenDialog">
                                                        </material-button>
                                                    </td>
                                                    <td v-if="set1 === 0" :rowspan="i.formDetails.length"
                                                        class="text-sm font-weight-normal text-center">
                                                        <material-button color="info" variant="outline"
                                                            class="rounded-circle me-1" data-bs-toggle="tooltip"
                                                            data-bs-placement="top" :title="btnEdit"
                                                            @click="showTkModal('update', i)"
                                                            :disabled="i.txStatus !== 'DRAFT'">
                                                            <i class="material-icons material-symbols-outlined">edit</i>
                                                        </material-button>
                                                        <material-button color="success" variant="outline"
                                                            class="rounded-circle me-1" data-bs-toggle="tooltip"
                                                            data-bs-placement="top" :title="btnApprove"
                                                            @click="onApprove(i)"
                                                            :disabled="i.txStatus !== 'DRAFT' || (i.refDocUid === '0' || i.refDocUid === null)">
                                                            <i
                                                                class="material-icons material-symbols-outlined">check</i>
                                                        </material-button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody v-if="listtk.length === 0">
                                                <tr>
                                                    <td colspan="8" class="text-sm font-weight-normal">
                                                        <p style="text-align: center">No Record Found</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colspan="15" style="text-align: right">Total Rows : {{
                                                        totalRows_sT }}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                                <pre></pre>
                                <div style=" display: flex; justify-content: flex-end">
                                    <ul v-show="listtk.length > 0" class="pagination justify-content-end">
                                        <div class="project-container">
                                            <div class="example-one">
                                                <vue-awesome-paginate v-model="currentPage_T" :total-items="totalRows_T"
                                                    :items-per-page="perPage_T" @click="onClickHandler_T" />
                                            </div>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="secondprePrint" class="tab-pane fade" role="tabpanel" aria-labelledby="second-prePrint">
                        <div class="card mt-2">
                            <div class="card-header">
                                <div class="row no-gutters">
                                    <div class="col-12 d-flex justify-content-between align-items-center">
                                        <h5>{{ $t("content.pawnshoplicense") }}</h5>
                                        <div>
                                            <material-button color="primary" class="float-lg-start float-sm-end mb-0"
                                                @click="showLcModal('add', null)">
                                                <i class="material-icons material-symbols-outlined">add</i>
                                                {{ btnAdd }}
                                            </material-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body pt-0">
                                <div class="row">
                                    <div class="col-lg-3">
                                        <label class="form-label ms-0">{{ $t("content.year") }}</label>
                                        <select v-model="yearslc_search" class="form-select">
                                            <option value="" disabled selected>{{ $t('content.select') }}</option>
                                            <option v-for="(a, sel2) in listyear" :key="sel2" :value="a">
                                                {{ a }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-lg-2">
                                        <label class="form-label ms-0 png"></label>
                                        <material-button color="primary" class="float-lg-start float-sm-end mb-3"
                                            @click="loadDataLc" :disabled="yearslc_search === ''">
                                            <i class="material-icons material-symbols-outlined">search</i>
                                            {{ btnSearch }}
                                        </material-button>
                                        <material-button id="licenseModal" data-bs-toggle="modal"
                                            data-bs-target="#newLicenseManageModal" v-show="false">
                                        </material-button>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="table-responsive">
                                        <table class="table table-flush">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th class="text-center">#</th>
                                                    <th class="text-center">{{ $t("content.licenseyear") }}</th>
                                                    <th class="text-center">{{ $t("content.licensebookno") }}</th>
                                                    <th class="text-center">{{ $t("content.licenseno") }}</th>
                                                    <th class="text-center">{{ $t("content.effedate") }}</th>
                                                    <th class="text-center">{{ $t("content.enddate") }}</th>
                                                    <th class="text-center">{{ $t("content.attach") }}</th>
                                                    <th width="100px">{{ $t("content.act") }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(row, index) in listlc" :key="index">
                                                    <td class="text-sm font-weight-normal text-center">
                                                        {{ formatNumberString((currentPage_L - 1) * perPage_L + index
                                                            + 1) }}
                                                    </td>
                                            
                                                    <td class="text-sm font-weight-normal text-center">
                                                        {{ Number(row.validYear) + 543 }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal text-center">
                                                        {{ row.licenseBookNo }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal text-center">
                                                        {{ row.licenseNo }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal text-center">
                                                        {{ format_date(row.fromDate) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal text-center">
                                                        {{ format_date(row.endDate) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal text-center">
                                                        <material-button color="info" variant="outline"
                                                            class="rounded-circle" data-bs-toggle="tooltip"
                                                            data-bs-placement="top" :title="btnPreview"
                                                            v-if="row.refDocUid !== '0' && row.refDocUid !== null"
                                                            @click="getFileRef(row)">
                                                            <i
                                                                class="material-icons material-symbols-outlined">attach_file</i>
                                                        </material-button>
                                                        <material-button color="primary" data-bs-toggle="modal"
                                                            data-bs-target="#attachmentsModal" v-show="false"
                                                            id="attachmenDialog">
                                                        </material-button>
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        <material-button color="info" variant="outline"
                                                            class="rounded-circle me-1" :title="btnEdit"
                                                            @click="showLcModal('update', row)">
                                                            <i class="material-icons material-symbols-outlined">edit</i>
                                                        </material-button>
                                                        <material-button color="danger" variant="outline"
                                                            class="rounded-circle me-1" data-bs-toggle="tooltip"
                                                            data-bs-placement="top" :title="btnDel"
                                                            @click="deleteRowItems(row)">
                                                            <i
                                                                class="material-icons material-symbols-outlined">delete</i>
                                                        </material-button>
                                                    </td>
                                                </tr>
                                                <tr v-if="listlc.length === 0">
                                                    <td colspan="8" class="text-sm font-weight-normal text-center">
                                                        <p style="text-align: center">No Record Found</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colspan="9" style="text-align: right">Total Rows :
                                                        {{ totalRows_sL }}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                                <pre></pre>
                                <div style="display: flex; justify-content: flex-end">
                                    <ul v-show="listlc.length > 0" class="pagination justify-content-end">
                                        <div class="project-container">
                                            <div class="example-one">
                                                <vue-awesome-paginate v-model="currentPage_L" :total-items="totalRows_L"
                                                    :items-per-page="perPage_L" @click="onClickHandler_Lc" />
                                            </div>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="thirdprePrint" class="tab-pane fade" role="tabpanel" aria-labelledby="third-prePrint">
                        <div class="card mt-2">
                            <div class="card-header">
                                <div class="row no-gutters">
                                    <div class="col-12 d-flex justify-content-between align-items-center">
                                        <h5>{{ $t("content.searchticketbook") }}</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body pt-0">
                                <div class="row">
                                    <div class="col-lg-3">
                                        <label class="form-label ms-0">{{ $t("content.shop_name") }}</label>
                                        <select v-model="shopcur_search" class="form-select"
                                            :disabled="shopList.length === 0">
                                            <option value="" disabled selected>{{ $t('content.select') }}</option>
                                            <option v-for="(item, index) in shopList" :value="item.uid" :key="index">
                                                {{ item.nameTh }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-lg-2">
                                        <label class="form-label ms-0 png"></label>
                                        <material-button color="primary" class="float-lg-start float-sm-end mb-3"
                                            :disabled="shopcur_search === ''" @click="getCurrent">
                                            <i class="material-icons material-symbols-outlined">search</i>
                                            {{ btnSearch }}
                                        </material-button>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="table-responsive">
                                        <table class="table table-flush">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th class="text-center">#</th>
                                                    <th class="text-center">{{ $t("content.shop_name") }}</th>
                                                    <th class="text-center">{{ $t("content.year") }}</th>
                                                    <th class="text-center">{{ $t("content.currentbookno") }}</th>
                                                    <th class="text-center">{{ $t("content.currentno") }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(row, index) in listcur" :key="index">
                                                    <td class="text-sm font-weight-normal text-center">
                                                        {{ formatNumberString(index + 1) }}
                                                    </td>

                                                    <td class="text-sm font-weight-normal text-center">
                                                        {{ filterShopName(row.shopUid) }}
                                                    </td>

                                                    <td class="text-sm font-weight-normal text-center">
                                                        {{ row.year }}
                                                    </td>

                                                    <td class="text-sm font-weight-normal text-center">
                                                        {{ formatNumberString(row.volNo) }}
                                                    </td>

                                                    <td class="text-sm font-weight-normal text-center">
                                                        {{ formatNumberString(Number(row.nextValue) - 1) }}
                                                    </td>

                                                </tr>
                                                <tr v-if="listcur.length === 0">
                                                    <td colspan="8" class="text-sm font-weight-normal text-center">
                                                        <p style="text-align: center">No Record Found</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colspan="9" style="text-align: right">Total Rows :
                                                        {{ listcur.length }}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


                <!-- Add New License Dialog -->
                <div id="newLicenseManageModal" class="modal fade" tabindex="-1"
                    aria-labelledby="newLicenseManageModalLabel" aria-hidden="true">
                    <div class="modal-dialog" style="max-width: 450px !important;">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title">{{ $t("content.pawnshoplicense") }}</h4>
                                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                                    <i class="material-icons material-symbols-outlined">close</i>
                                </button>
                            </div>

                            <div class="modal-body">
                                <fieldset>
                                    <div class="row">
                                        <div class="table-responsive">
                                            <table class="table table-flush">
                                                <tbody>
                                                    <tr>
                                                        <td class="text-sm font-weight-normal">{{
                                                            $t("content.licenseyear") }}</td>
                                                        <td class="text-sm font-weight-normal">
                                                            <select v-model="lc_detail.year_bc" class="form-select">
                                                                <option value="" disabled selected>{{ $t('content.select') }}</option>
                                                                <option v-for="(a, sel2) in yearbc" :key="sel2" :value="a">
                                                                    {{ a }}
                                                                </option>
                                                            </select>    
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-sm font-weight-normal">{{
                                                            $t("content.licensebookno") }}</td>
                                                        <td class="text-sm font-weight-normal">
                                                            <material-input type="text" class="input-center"
                                                                v-model="lc_detail.licenseBookNo"
                                                                @input="onlyDigit_LcBookNo" />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-sm font-weight-normal">{{
                                                            $t("content.licenseno") }}</td>
                                                        <td class="text-sm font-weight-normal">
                                                            <material-input type="text" class="input-center"
                                                                v-model="lc_detail.licenseNo" />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-sm font-weight-normal">{{
                                                            $t("content.licenseowner") }}</td>
                                                        <td class="text-sm font-weight-normal">
                                                            <material-input v-model="lc_detail.licenseOwner" type="text"
                                                                class="input-center" disabled />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-sm font-weight-normal">{{ $t("content.effedate")
                                                            }}</td>
                                                        <td class="text-sm font-weight-normal">
                                                            <VueDatePicker id="responseDate"
                                                                v-model="lc_detail.fromDate" :format="format" auto-apply
                                                                :teleport="true" :enable-time-picker="false"
                                                                month-name-format="long" :clearable="false" fluid
                                                                :text-input="textInputOptions" />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-sm font-weight-normal">{{ $t("content.enddate")
                                                            }}</td>
                                                        <td class="text-sm font-weight-normal">
                                                            <VueDatePicker id="responseDate" v-model="lc_detail.endDate"
                                                                :format="format" auto-apply :teleport="true"
                                                                :enable-time-picker="false" month-name-format="long"
                                                                :clearable="false" fluid
                                                                :text-input="textInputOptions" />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-sm font-weight-normal">{{ $t("content.attach")
                                                            }}</td>
                                                        <td class="text-sm font-weight-normal">
                                                            <input id="uploadlc" type="file"
                                                                accept="application/pdf,image/*" @change="addFile" />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>

                            <div class="modal-footer justify-content-between">
                                <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
                                    {{ btnCancel }}
                                </button>
                                <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                                    :disabled="lc_detail.year_bc === '' || lc_detail.licenseBookNo === '' || lc_detail.licenseBookNo === 0 || lc_detail.licenseNo === ''
                                        || lc_detail.fromDate === null || lc_detail.endDate === null || new Date(lc_detail.fromDate) > new Date(lc_detail.endDate)"
                                    @click="checkProcessLc">
                                    {{ btnSave }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Attachments Dialog -->
                <div id="attachmentsModal" class="modal fade" tabindex="-1" aria-labelledby="lookupModalLabel"
                    aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" style="max-width: 520px">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title">{{ $t("content.detail") }}</h4>
                                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                                    <i class="material-icons material-symbols-outlined">close</i>
                                </button>
                            </div>

                            <div class="modal-body">
                                <div id="attachmentsImages" class="carousel slide" data-bs-ride="carousel">
                                    <div class="carousel-indicators" id="demo2">
                                    </div>
                                    <div class="carousel-inner" id="demo3">
                                    </div>
                                    <button class="carousel-control-prev" type="button"
                                        data-bs-target="#attachmentsImages" data-bs-slide="prev">
                                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span class="visually-hidden">Previous</span>
                                    </button>
                                    <button class="carousel-control-next" type="button"
                                        data-bs-target="#attachmentsImages" data-bs-slide="next">
                                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span class="visually-hidden">Next</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Add New Dialog -->
                <div id="newTkFormModal" class="modal fade" tabindex="-1" aria-labelledby="newTkFormModalLabel"
                    aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title">{{ $t("content.pawnticketbook") }} {{ listtk_new.length }}/5
                                </h4>
                                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                                    <i class="material-icons material-symbols-outlined">close</i>
                                </button>
                            </div>

                            <div class="modal-body">
                                <fieldset>
                                    <div class="row">
                                        <div class="col-12 mt-3">
                                            <div class="table-responsive">
                                                <table class="table table-flush">
                                                    <tbody>
                                                        <tr>
                                                            <td class="text-sm font-weight-normal">{{
                                                                $t("content.date") }}
                                                            </td>
                                                            <td class="text-sm font-weight-normal">{{
                                                                format_date(tk_detail.requestDate) }}
                                                            </td>
                                                            <td class="text-sm font-weight-normal">{{
                                                                $t("content.bookyear") }}
                                                            </td>
                                                            <td class="text-sm font-weight-normal">
                                                               <select v-model="tk_detail.validYear" class="form-select" @change="listByShopApi()">
                                                                <option value="" disabled selected>{{ $t('content.select') }}</option>
                                                                <option v-for="(a, sel2) in year_eff" :key="sel2" :value="a">
                                                                    {{ a }}
                                                                </option>
                                                               </select>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-sm font-weight-normal">{{
                                                                $t("content.attach")
                                                                }}</td>
                                                            <td class="text-sm font-weight-normal" colspan="2">
                                                                <input id="uploadtk" type="file"
                                                                    accept="application/pdf,image/*" @change="addFile"
                                                                    :disabled="tk_detail.uid === '' || tk_detail.validYear === ''"  />
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td class="text-sm font-weight-normal">{{
                                                                $t("content.shop_name") }}</td>
                                                            <td class="text-sm font-weight-normal">
                                                                <select v-model="tk_detail.shopUid"
                                                                    class="form-select profile"
                                                                    :disabled="shopList.length === 0 || tk_detail.validYear === '' || listtk_shop.length === 0"
                                                                    @change="filterLastestBook()">
                                                                    <option value="" disabled selected>{{
                                                                        $t("content.select") }}</option>
                                                                    <option v-for="(item, index) in shopList"
                                                                        :value="item.uid" :key="index"
                                                                        :disabled="filterListTk(item.uid)">
                                                                        {{ item.nameTh }}
                                                                    </option>
                                                                </select>
                                                            </td>
                                                            <td class="text-sm font-weight-normal">{{
                                                                $t("content.bookreqlast") }}</td>
                                                            <td class="text-sm font-weight-normal">
                                                                <material-input v-model="tk_detail.lastest" type="text"
                                                                    class="input-center" disabled />
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td class="text-sm font-weight-normal">{{
                                                                $t("content.bookstart") }}
                                                            </td>
                                                            <td class="text-sm font-weight-normal">
                                                                <material-input type="text" class="input-center"
                                                                    v-model="tk_detail.start" disabled />
                                                            </td>
                                                            <td class=" text-sm font-weight-normal">{{
                                                                $t("content.bookend")
                                                                }}
                                                            </td>
                                                            <td class="text-sm font-weight-normal">
                                                                <material-input type="text" class="input-center"
                                                                    v-model="tk_detail.end" disabled />
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td class="text-sm font-weight-normal">{{
                                                                $t("content.bookamount") }}</td>
                                                            <td class="text-sm font-weight-normal">
                                                                <material-input type="text" class="input-center"
                                                                    v-model="tk_detail.count" @input="onlyDigit_tk" :disabled="tk_detail.validYear === ''|| listtk_shop.length === 0" />
                                                            </td>

                                                            <td class="text-sm font-weight-normal" colspan="2">
                                                                <div
                                                                    class="col-1 d-flex justify-content-between align-items-center">
                                                                    <material-checkbox v-model="tk_detail.req"
                                                                        :checked="tk_detail.req" :disabled="tk_detail.validYear === ''|| listtk_shop.length === 0"
                                                                        class="d-inline-block mb-0 me-4">
                                                                        {{ $t("content.shop_name_req") }}
                                                                    </material-checkbox>

                                                                    <div>
                                                                        <material-button color="primary"
                                                                            variant="outline"
                                                                            class="rounded-circle ms-1"
                                                                            data-bs-toggle="tooltip"
                                                                            data-bs-placement="top" :title="btnAddNew"
                                                                            @click="addTkBookList"
                                                                            :disabled="tk_detail.validYear === '' ||tk_detail.shopUid === '' || tk_detail.count === null || tk_detail.count === '' || Number(tk_detail.count) === 0 || listtk_new.length >= 5 || listtk_shop.length === 0">
                                                                            <i
                                                                                class="material-icons material-symbols-outlined">add</i>
                                                                        </material-button>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="col-12 mt-3">
                                            <div class="table-responsive">
                                                <table class="table table-sm table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>{{ $t("content.shop_name") }}</th>
                                                            <th class="text-sm font-weight-normal text-center">
                                                                {{ $t("content.bookreqlast") }}
                                                            </th>
                                                            <th class="text-sm font-weight-normal text-center">
                                                                {{ $t("content.bookstart") }}
                                                            </th>
                                                            <th class="text-sm font-weight-normal text-center">
                                                                {{ $t("content.bookend") }}
                                                            </th>
                                                            <th class="text-sm font-weight-normal text-center">
                                                                {{ $t("content.bookamount") }}
                                                            </th>
                                                            <th class="text-sm font-weight-normal text-center">
                                                                {{ $t("content.shop_name_req") }}
                                                            </th>
                                                            <th>{{ $t("content.act") }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(row, index) in listtk_new" :key="index">
                                                            <td class="text-sm font-weight-normal">{{
                                                                formatNumberString(index + 1) }}</td>
                                                            <td class="text-sm font-weight-normal">
                                                                {{ filterShopName(row.shopUid) }}
                                                            </td>
                                                            <td class="text-sm font-weight-normal text-center">
                                                                {{ formatNumberString(row.lastest) }}
                                                            </td>
                                                            <td class="text-sm font-weight-normal text-center">
                                                                {{ formatNumberString(row.startVolNo) }}
                                                            </td>
                                                            <td class="text-sm font-weight-normal text-center">
                                                                {{ formatNumberString(row.endVolNo) }}
                                                            </td>
                                                            <td class="text-sm font-weight-normal text-center">
                                                                {{ formatNumberString(Number(row.endVolNo)
                                                                    - Number(row.startVolNo) + 1) }}
                                                            </td>
                                                            <td class="text-sm font-weight-normal text-center">
                                                                <material-checkbox v-model="row.req" :checked="row.req"
                                                                    disabled />
                                                            </td>
                                                            <td class="text-sm font-weight-normal">
                                                                <material-button color="danger" variant="outline"
                                                                    class="rounded-circle ms-1" data-bs-toggle="tooltip"
                                                                    data-bs-placement="top" :title="btnDel"
                                                                    @click="delTkBookList(index)">
                                                                    <i
                                                                        class="material-icons material-symbols-outlined">close</i>
                                                                </material-button>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="listtk_new.length === 0">
                                                            <td colspan="8" class="text-sm font-weight-normal">
                                                                <p style="text-align: center">No Record Found</p>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                            <!-- :disabled="!filterTkReq() || listtk_new.length === 0" -->
                            <div class="modal-footer justify-content-between">
                                <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
                                    {{ btnCancel }}
                                </button>
                                <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                                    @click="checkProcessTk">
                                    {{ btnSave }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { reactive, inject, computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import ProgressSpinner from 'primevue/progressspinner';
import moment from 'moment'
import Modal from 'bootstrap/js/dist/modal';
import ExampleFive from "@/examples/ExampleOne";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import axios from "axios";
import * as st from "@/config/setting.js";

import { useShopTicketsStore } from '@/stores/shoptickets'
import { useShopLicenseStore } from '@/stores/shoplicense'
import { useDocumentStore } from '@/stores/document'
import { useVolNoStore } from '@/stores/volno'
import { useShopStore } from '@/stores/shop'


const storetk = useShopTicketsStore()
const storelc = useShopLicenseStore()
const storedoc = useDocumentStore()
const storevol = useVolNoStore()
const storesh = useShopStore()


const { t } = useI18n();
const swal = inject("$swal");

const btnEdit = computed(() => t("buttons.edit"));
const btnSearch = computed(() => t("buttons.sear"))
const btnSave = computed(() => t("buttons.save"));
const btnDel = computed(() => t("buttons.remo"));
const btnAdd = computed(() => t("buttons.addd"));
const btnCancel = computed(() => t("buttons.canc"));
const btnPreview = computed(() => t("content.file"))
const btnAddBook = computed(() => t("content.bookreqbtn"))
const btnApprove = computed(() => t("buttons.approve"));
const btnAddNew = computed(() => t("buttons.impo"))
const btnPcover = computed(() => t("content.branch_cover"))
const btnPBlank = computed(() => t("content.branch_blank"))


const shopList = ref([]);
const shop_detail = ref(null);
const yearslc_search = ref('');
const statustk_search = ref('');
const shoptk_search = ref('');
const shopcur_search = ref('');

const listtk = ref([]);
const listlc = ref([]);
const listtk_shop = ref([]);
const listtk_new = ref([]);
const listcur = ref([]);
const listcover = ref([]);
const shop_info = ref(null);

const currentPage_T = ref(1);
const totalRows_T = ref(1);
const perPage_T = ref(10);
const totalRows_sT = ref();

const currentPage_L = ref(1);
const totalRows_L = ref(1);
const perPage_L = ref(10);
const totalRows_sL = ref();

const key = JSON.parse(localStorage.getItem("shop_seleted"));

const loading = ref(false);
const regex = /data:.*base64,/
const thumb_id = ref('');
const mimeType = ref("");
const thumb_name = ref('');
const thumb = ref(null);
const images = ref([])

const listyear = generateYearsArray();


const year_eff = computed(() =>
    Array.from({ length: 2 }, (_, i) => formatyear(new Date(new Date().setFullYear(new Date().getFullYear() + i))))
);

const yearbc = computed(() =>
    Array.from({ length: 2 }, (_, i) => formatyear(new Date(new Date().setFullYear(new Date().getFullYear() +i+543))))
);

const textInputOptions = {
    format: 'dd/MM/yyyy'
};

const format = (date) => {
    return moment(String(date)).local().format('DD/MM/YYYY');
}

const formatyear = (date) => {
    return moment(String(date)).local().format('YYYY');
}

function format_date(value) {
    if (value) {
        return moment(String(value)).local().format('DD/MM/YYYY')
    }
}

function formatNumberString(num) {
    return String(num).replace(
        /(\d)(?=(\d{3})+(?!\d))/g,
        "$1,"
    );
}


function generateYearsArray() {
  const currentYear = new Date().getFullYear();
  const years = [];
  // Add next year
    years.push(currentYear + 1);

  // Add current year
  years.push(currentYear);  

  // Add previous 2 years
  for (let i = 1; i < 3; i++) { 
    years.push(currentYear - i);
  }

  return years;
}


const onClickHandler_T = (page) => {
    updatePaginationLc()
};


const onClickHandler_Lc = (page) => {
    updatePaginationLc()
};

const tk_detail = ref({
    uid: '',
    groupUid: '',
    shopUid: '',
    validYear: '',
    shopOwner: '',
    fullname: '',
    address: '',
    requestDate: new Date(),
    formDetails: '',
    refDocUid: '0',
    approveDate: null,
    txStatus: '',
    version: '',
    lastest: '',
    start: '',
    end: '',
    count: '',
    req: false
})
const lc_detail = ref({
    uid: '',
    shopUid: '',
    validYear: '',
    licenseBookNo: '',
    licenseNo: '',
    allowShopName: '',
    licenseOwner: '',
    shopAddress: '',
    fromDate: new Date(),
    endDate: new Date(),
    refDocUid: '0',
    version: '',
    year_bc: '',
})



const infoshop = async (val) => {
    shopList.value = []
    if (localStorage.getItem("shoplist") !== null) {
        shopList.value = JSON.parse(localStorage.getItem("shoplist"));
        // console.log("shopList dash : ", shopList.value);
    }
    let data = "";
    shop_detail.value = null
    data = {
        index: "0",
        size: "1",
        shopUid: key.uid,
        validYear: formatyear(new Date(new Date().setFullYear(new Date().getFullYear() - 0)))
    };
    const payload = data;
    // console.log('payload : ' + JSON.stringify(payload));
    const response = await storelc.shopLicenseListFetch(payload);
    // console.log('info res : ' + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                shop_detail.value = response.data.data.list[0]
                // console.log('shoplicense: ' + JSON.stringify(shop_detail.value));
            }
        }
    }
}

infoshop()


async function addFile(e) {
    thumb.value = null
    thumb_name.value = ""
    mimeType.value = ""
    if (e.target.files[0] !== undefined) {
        thumb.value = await toBase64(e.target.files[0])
        let today = moment(new Date()).local().format('YYYYMMDD_HHmmss')
        thumb_name.value = 'file_' + today
        if (e.target.files[0].type === "image/jpeg") {
            thumb_name.value = thumb_name.value + ".jpg"
            mimeType.value = "image/jpeg"
        } else if (e.target.files[0].type === "image/png") {
            thumb_name.value = thumb_name.value + ".png"
            mimeType.value = "image/png"
        } else if (e.target.files[0].type === 'application/pdf') {
            thumb_name.value = thumb_name.value + ".pdf"
            mimeType.value = "application/pdf"
        }
    }
}

const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.replace('data:', '')
        .replace(/^.+,/, ''));
    reader.onerror = reject;
});

async function onlyDigit_tk() {
    if (tk_detail.value.count !== "") {
        if (tk_detail.value.count.match(/^[0-9]+$/)) {
            tk_detail.value.count = tk_detail.value.count.match(/^[0-9]+$/);
            await checktkcount()
        } else {
            tk_detail.value.count = tk_detail.value.count.slice(0, -1);
            await checktkcount()
        }
    } else {
        tk_detail.value.count = "";
    }
}


async function checktkcount() {
    tk_detail.value.end = ""
    if (tk_detail.value.count !== "" && tk_detail.value.start !== "") {
        tk_detail.value.end = parseInt(tk_detail.value.count) + parseInt(tk_detail.value.lastest)
        tk_detail.value.end = formatNumberString(tk_detail.value.end)
    }
}


async function onlyDigit_LcBookNo() {

    if (lc_detail.value.licenseBookNo !== "") {
        if (lc_detail.value.licenseBookNo.match(/^[0-9]+$/)) {
            lc_detail.value.licenseBookNo = lc_detail.value.licenseBookNo.match(/^[0-9]+$/);

        } else {
            lc_detail.value.licenseBookNo = lc_detail.value.licenseBookNo.slice(0, -1);
        }
    } else {
        lc_detail.value.licenseBookNo = "";
    }
}


const loadDataTk = async (val) => {
    let data = "";


    if (shoptk_search.value !== '' || statustk_search.value !== '') {
        currentPage_T.value = 1
    }

    data = {
        index: currentPage_T.value - 1,
        size: perPage_T.value,
        shopUid: shoptk_search.value,
        groupUid: key.groupUid,
        txStatus: statustk_search.value
    };

    const payload = data;
    // console.log("payload : " + JSON.stringify(payload));
    const response = await storetk.listFormFetch(payload);
    // console.log("loadDataTk r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                listtk.value = response.data.data.list;
                totalRows_T.value = response.data.data.ext.total
                totalRows_sT.value = formatNumberString(totalRows_T.value)
            }
        }
    }
}


const loadDataLc = async (val) => {
    let data = "";
    if (currentPage_L.value !== 1) {
        if (listlc.value.length === 1 && val === 'del') {
            currentPage_L.value = currentPage_L.value - 1
        }
    }

    if (yearslc_search.value !== '' && val !== 'del') {
        currentPage_L.value = 1
    }

    data = {
        index: currentPage_L.value - 1,
        size: perPage_L.value,
        shopUid: key.uid,
        validYear: yearslc_search.value,
    };

    const payload = data;
    // console.log("payload : " + JSON.stringify(payload));
    const response = await storelc.shopLicenseListFetch(payload);
    // console.log("loadDataLc r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                listlc.value = response.data.data.list;
                totalRows_L.value = response.data.data.ext.total
                totalRows_sL.value = formatNumberString(totalRows_L.value)
            }
        }
    }
}

async function updatePaginationT() {
    let data = "";
    listtk.value = []
    data = {
        index: currentPage_T.value - 1,
        size: perPage_T.value,
        shopUid: shoptk_search.value,
        groupUid: key.groupUid,
        txStatus: statustk_search.value
    };

    const payload = data;
    // console.log("payload : " + JSON.stringify(payload));
    const response = await storetk.listFormFetch(payload);
    // console.log("loadDataTk r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                listtk.value = response.data.data.list;
                totalRows_T.value = response.data.data.ext.total
                totalRows_sT.value = formatNumberString(totalRows_T.value)
            }
        }
    }

}


async function updatePaginationLc() {
    listlc.value = []
    let data = "";
    data = {
        index: currentPage_L.value - 1,
        size: perPage_L.value,
        shopUid: key.uid,
        validYear: yearslc_search.value,
    };

    const payload = data;
    // console.log("payload : " + JSON.stringify(payload));
    const response = await storelc.shopLicenseListFetch(payload);
    // console.log("loadDataApi : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                listlc.value = response.data.data.list;
                totalRows_L.value = response.data.data.ext.total
                totalRows_sL.value = formatNumberString(totalRows_L.value)
            }
        }
    }


}

function clearItemsTk() {
    tk_detail.value = {
        uid: '',
        groupUid: '',
        shopUid: '',
        validYear: '',
        shopOwner: '',
        fullname: '',
        address: '',
        requestDate: new Date(),
        formDetails: '',
        refDocUid: '0',
        approveDate: null,
        txStatus: '',
        version: '',
        lastest: '',
        start: '',
        end: '',
        count: '',
        req: false
    }

}


function clearItemsLc() {
    lc_detail.value = {
        uid: '',
        shopUid: '',
        validYear: '',
        licenseBookNo: '',
        licenseNo: '',
        allowShopName: '',
        licenseOwner: key.shopOwner,
        shopAddress: '',
        fromDate: new Date(),
        endDate: new Date(),
        refDocUid: '0',
        version: '',
        year_bc: '',
    }
    document.getElementById("uploadlc").value = null;
}


async function showTkModal(process, item) {
    clearItemsTk()
    if (process === 'update') {
        tk_detail.value.uid = item.uid
        tk_detail.value.groupUid = item.groupUid
        tk_detail.value.validYear = item.validYear
        tk_detail.value.requestDate = item.requestDate
        tk_detail.value.formDetails = item.formDetails
        tk_detail.value.refDocUid = item.refDocUid
        tk_detail.value.approveDate = item.approveDate
        tk_detail.value.txStatus = item.txStatus
        tk_detail.value.version = item.version
        listtk_new.value = item.formDetails

        listtk_new.value.forEach(function (obj) {
            obj.lastest = 0;
            obj.req = false;
        });

        for (let i = 0; i < listtk_new.value.length; i++) {
            listtk_new.value[i].lastest = Number(listtk_new.value[i].startVolNo) - 1
            if (listtk_new.value[i].shopUid === item.shopUid) {
                listtk_new.value[i].req = true
            }
        }
        // console.log("listtk_new : " + JSON.stringify(listtk_new.value));
    } else {
        listtk_new.value = []
    }
    // console.log('tk_detail : ' + JSON.stringify(tk_detail.value));
    thumb.value = null
    thumb_name.value = ""
    mimeType.value = ""
    document.getElementById("uploadtk").value = null;
    const myModal = document.getElementById('newTkFormModal');
    const modal = new Modal(myModal); // Instantiates your modal
    modal.show();
}

async function showLcModal(process, item) {
    clearItemsLc()
    if (process === 'update') {
        lc_detail.value.uid = item.uid
        lc_detail.value.shopUid = item.shopUid
        lc_detail.value.validYear = item.validYear
        lc_detail.value.licenseBookNo = item.licenseBookNo
        lc_detail.value.licenseNo = item.licenseNo
        lc_detail.value.allowShopName = item.allowShopName
        lc_detail.value.licenseOwner = item.licenseOwner
        lc_detail.value.fromDate = item.fromDate
        lc_detail.value.endDate = item.endDate
        lc_detail.value.refDocUid = item.refDocUid
        lc_detail.value.version = item.version
        lc_detail.value.shopAddress = item.address
        lc_detail.value.year_bc = new Date(item.validYear).getFullYear() + 543
    }
    // console.log('lc_detail : ' + JSON.stringify(lc_detail.value));
    document.getElementById("licenseModal").click();
}

async function deleteRowItems(item) {
    swal({
        title: "ลบรายการ",
        text: "คุณต้องการลบรายการนี้ใช่ไหม",
        icon: "warning",
        allowOutsideClick: false,
        showCloseButton: false,
        showCancelButton: true,
        closeOnConfirm: false,
        focusConfirm: false,
        animation: "slide-from-top",
        confirmButtonText: t("buttons.conf"),
        cancelButtonText: t("buttons.canc"),
    }).then((result) => {
        if (result.isConfirmed) {
            if (item.uid !== "") {
                deleteLc(item.uid)
            }
        }
    });
}


async function checkProcessTk() {
    if (tk_detail.value.uid !== "") {
        await updateTk()
    } else {
        await addTk()
    }
}

async function checkProcessLc() {
    if (lc_detail.value.uid !== "") {
        await updateLc()
    } else {
        await addLc()
    }
}

async function addTk() {
    let lp = listtk_new.value.filter((c) => c.req === true);
    let reqshop = []
    if (lp.length > 0) {
        reqshop = filterShopDetail(lp[0].shopUid)
    }
    const formDetails = listtk_new.value
    formDetails.forEach(object => {
        delete object['lastest'];
        delete object['req'];
    });

    let fullname = ''
    let address = ''

    if (reqshop[0].fullname !== null) {
        fullname = reqshop[0].fullname
    }

    if (reqshop[0].address !== null) {
        address = reqshop[0].address
    }

    const payload = {
        groupUid: reqshop[0].groupUid,
        shopUid: reqshop[0].uid,
        validYear: tk_detail.value.validYear,
        shopOwner: reqshop[0].shopOwner,
        fullname: fullname,
        address: address,
        requestDate: moment(new Date(tk_detail.value.requestDate)).format('YYYY-MM-DD'),
        formDetails: formDetails,
    };
    // console.log('addtk p : ' + JSON.stringify(payload));
    const response = await storetk.shopTicketsAddFetch(payload);
    // console.log('addtk r : ' + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                clearItemsTk()
                swal("บันทึกสำเร็จ", "", "success");
                loadDataTk('add')
            } else {
                swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
            }
        }
    }
}

async function updateTk() {
    thumb_id.value = tk_detail.value.refDocUid
    if (thumb.value !== null && thumb_name.value !== '') {
        thumb_id.value = '0'
        await addfileApi()
    }
    let lp = listtk_new.value.filter((c) => c.req === true);
    let reqshop = []
    if (lp.length > 0) {
        reqshop = filterShopDetail(lp[0].shopUid)
    }

    const formDetails = listtk_new.value
    formDetails.forEach(object => {
        delete object['lastest'];
        delete object['req'];
    });

      let fullname = ''
    let address = ''

    if (reqshop[0].fullname !== null) {
        fullname = reqshop[0].fullname
    }

    if (reqshop[0].address !== null) {
        address = reqshop[0].address
    }

    const payload = {
        uid: tk_detail.value.uid,
        groupUid: reqshop[0].groupUid,
        shopUid: reqshop[0].uid,
        validYear: tk_detail.value.validYear,
        shopOwner: reqshop[0].shopOwner,
        fullname: fullname,
        address: address,
        requestDate: moment(new Date(tk_detail.value.requestDate)).format('YYYY-MM-DD'),
        formDetails: formDetails,
        approveDate: tk_detail.value.approveDate,
        txStatus: tk_detail.value.txStatus,
        version: tk_detail.value.version,
        refDocUid: thumb_id.value,
    };
    // console.log('updateTk p : ' + JSON.stringify(payload));
    const response = await storetk.shopTicketsUpdateFetch(payload);
    // console.log('updateTk res : ' + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                swal("บันทึกสำเร็จ", "", "success");
                loadDataTk('update')
            } else {
                swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
            }
        }
    }
}

async function approveTk(item) {
    const payload = {
        uid: item.uid,
        refDocUid: item.refDocUid,
        approveDate: moment(new Date()).format('YYYY-MM-DD'),
    };
    // console.log('apptk p : ' + JSON.stringify(payload));
    const response = await storetk.shopTicketsApproveFetch(payload);
    // console.log('apptk r : ' + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                clearItemsTk()
                swal("บันทึกสำเร็จ", "", "success");
                loadDataTk('update')
            } else {
                swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
            }
        }
    }
}


async function addLc() {
    thumb_id.value = '0'
    if (thumb.value !== null && thumb_name.value !== '') {
        await addfileApi()
    }
    const payload = {
        shopUid: key.uid,
        validYear: String(Number(lc_detail.value.year_bc)-543),
        licenseBookNo: Number(lc_detail.value.licenseBookNo),
        licenseNo: lc_detail.value.licenseNo,
        allowShopName: key.fullname,
        licenseOwner: lc_detail.value.licenseOwner,
        fromDate: moment(new Date(lc_detail.value.fromDate)).format('YYYY-MM-DD'),
        endDate: moment(new Date(lc_detail.value.endDate)).format('YYYY-MM-DD'),
        refDocUid: thumb_id.value,
        shopAddress: key.address,
    };

    // console.log('addLc p : ' + JSON.stringify(payload));
    const response = await storelc.shopLicenseAddFetch(payload);
    // console.log('addLc r : ' + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                clearItemsLc()
                swal("บันทึกสำเร็จ", "", "success");
                loadDataLc('add')
            } else {
                swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
            }
        }
    }
}

async function updateLc() {
    thumb_id.value = lc_detail.value.refDocUid
    if (thumb.value !== null && thumb_name.value !== '') {
        thumb_id.value = '0'
        await addfileApi()
    }
    const payload = {
        uid: lc_detail.value.uid,
        shopUid: key.uid,
        validYear: String(Number(lc_detail.value.year_bc)-543),
        licenseBookNo: Number(lc_detail.value.licenseBookNo),
        licenseNo: lc_detail.value.licenseNo,
        allowShopName: key.fullname,
        licenseOwner: lc_detail.value.licenseOwner,
        fromDate: moment(new Date(lc_detail.value.fromDate)).format('YYYY-MM-DD'),
        endDate: moment(new Date(lc_detail.value.endDate)).format('YYYY-MM-DD'),
        refDocUid: thumb_id.value,
        shopAddress: key.address,
        version: lc_detail.value.version,
    };
    // console.log('updateLc p : ' + JSON.stringify(payload));
    const response = await storelc.shopLicenseUpdateFetch(payload);
    // console.log('updateLc r : ' + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                clearItemsLc()
                swal("บันทึกสำเร็จ", "", "success");
                loadDataLc('update')
            } else {
                swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
            }
        }
    }
}

async function deleteLc(id) {
    let data = "";
    data = {
        uid: id,
    };
    const payload = data;
    // console.log('add payload : ' + JSON.stringify(payload));
    const response = await storelc.shopLicenseDeleteFetch(payload);
    // console.log('add res : ' + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                clearItemsLc()
                swal("บันทึกสำเร็จ", "", "success");
                loadDataLc('del')
            } else {
                swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
            }
        }
    }
}


async function listByShopApi() {
    loading.value = true
    listtk_shop.value = []
    tk_detail.value.shopUid = ''
    filterLastestBook()
    tk_detail.value.req = false
    let data = "";
    data = {
        uid: tk_detail.value.validYear,
    };
    const payload = data;
    // console.log("listByShopApi p : " + JSON.stringify(payload));
    const response = await storetk.listByShopFetch(payload);
    // console.log("listByShopApi r : " + JSON.stringify(response.data));
    loading.value = false
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                listtk_shop.value = response.data.data;
            }
        }
    }
}


function filterLastestBook() {
    tk_detail.value.lastest = ''
    tk_detail.value.start = ''
    tk_detail.value.end = ''
    tk_detail.value.count = ''
    if (tk_detail.value.shopUid !== '') {
        let list = []
        let lp = listtk_shop.value.filter((c) => c.shopUid === tk_detail.value.shopUid);
        list = lp
        if (list[0].lastVolNo !== null && list[0].lastVolNo !== undefined){ 
            tk_detail.value.lastest = list[0].lastVolNo
        }else{
            tk_detail.value.lastest = 0
        }
        tk_detail.value.start = Number(tk_detail.value.lastest) + 1
    }
}

function filterShopDetail(val) {
    let lp = shopList.value.filter((c) => c.uid === val);
    return lp
}

function filterShopName(val) {
    let name = ''
    let lp = shopList.value.filter((c) => c.uid === val);
    if (lp.length > 0) {
        name = lp[0].nameTh
    }
    return name
}

function filterListTk(val) {
    let process = false
    let lp = listtk_new.value.filter((c) => c.shopUid === val);
    if (lp.length > 0) {
        process = true
    }
    return process
}

function filterTkReq() {
    let process = false
    let lp = listtk_new.value.filter((c) => c.req === true);
    if (lp.length > 0) {
        process = true
    }
    return process
}

async function addTkBookList() {
    let year = tk_detail.value.validYear
    let list = filterShopDetail(tk_detail.value.shopUid)
    if (list.length > 0) {
        if (tk_detail.value.req) {
            for (let i = 0; i < listtk_new.value.length; i++) {
                if (listtk_new.value[i].req) {
                    listtk_new.value[i].req = false
                }
            }
        }

        let obj = {
            "shopUid": list[0].uid,
            "fullname": list[0].fullname,
            "shopOwner": list[0].shopOwner,
            "startVolNo": Number(tk_detail.value.start),
            "endVolNo": Number(tk_detail.value.end),
            "req": tk_detail.value.req,
            "lastest": Number(tk_detail.value.lastest)
        }
        listtk_new.value.push(obj)
        if (tk_detail.value.uid === '') {
            clearItemsTk()
            tk_detail.value.validYear = year
        } else {
            tk_detail.value.shopUid = ''
            tk_detail.value.fullname = ''
            tk_detail.value.shopOwner = ''
            tk_detail.value.start = ''
            tk_detail.value.end = ''
            tk_detail.value.req = false
            tk_detail.value.lastest = ''
        }

    }
}

async function delTkBookList(index) {
    listtk_new.value.splice(index, 1);
}



async function addfileApi() {
    let data = "";
    let trimmedString = String(thumb.value).replace(regex, "")
    data = {
        forGroupUid: "",
        forShopUid: "",
        name: thumb_name.value,
        data: trimmedString,
        mimeType: mimeType.value,
    };

    const payload = data;
    const response = await storedoc.addFetch(payload);
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                thumb_id.value = response.data.data.uid
            } else {
                swal("บันทึกไฟล์ไม่สำเร็จ", response.data.rtnDesc, "error");
            }
        }
    }
}

async function getFileRef(item) {
    loading.value = true
    let url = []
    images.value = []
    url.push(String(st.url_api + "/doc-svc/document/info/" + item.refDocUid));
    if (url.length > 0) {
        await getFile(url)
        if (images.value.length > 0) {
            if (images.value[0].title === 'application/pdf') {
                window.open(images.value[0].src, '_blank').focus();
            } else {
                setGallery2()
                document.getElementById("attachmenDialog").click();
            }

            loading.value = false
        }
    }
}


async function getFile(urls) {
    let file_L = []
    const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-admin"));
    const accessToken = keya.accessToken;
    axios.defaults.headers["Authorization"] = `Bearer ${accessToken}`;
    const requests = urls.map((url) => axios.get(url));
    await Promise.all(requests).then(allResults => {
        if (allResults) {
            file_L = allResults
            if (file_L !== null) {
                for (let i = 0; i < file_L.length; i++) {
                    if (file_L[i].data.data !== null) {
                        const file = getFileFromBase64(file_L[i].data.data.data, file_L[i].data.data.name)
                        const data = URL.createObjectURL(file);
                        let obj = {
                            src: data,
                            thumbnailImageSrc: data,
                            alt: '',
                            title: file.type,
                            filename: file_L[i].data.data.name,
                        }
                        images.value.push(obj)
                    } else {
                        loading.value = false
                    }
                }
            }
        }
    })

}


function getFileFromBase64(string64, fileName) {
    const trimmedString = string64.replace('dataimage/jpegbase64', '');
    var ext = fileName.split('.').pop();
    let type = '';
    let imageContent = null
    if (ext === 'jpg') {
        type = 'image/jpeg'
    } else if (ext === 'png') {
        type = 'image/png'
    } else if (ext === 'pdf') {
        type = 'application/pdf'
    }

    if (type === 'application/pdf') {
        imageContent = atob(string64);
    } else {
        imageContent = atob(trimmedString);
    }

    const buffer = new ArrayBuffer(imageContent.length);
    const view = new Uint8Array(buffer);

    for (let n = 0; n < imageContent.length; n++) {
        view[n] = imageContent.charCodeAt(n);
    }

    const blob = new Blob([buffer], { type });
    return new File([blob], fileName, { lastModified: new Date().getTime(), type });
}




function setGallery2() {

    var x = "", i, y = "";

    for (i = 0; i < images.value.length; i++) {

        if (i == 0) {
            x = x + '<div class="carousel-item active"> ' +
                '<img src="' + images.value[i].src + '" class="d-block w-100" alt="..." />' +
                '</div>';
            y = y + '<button type = "button" data-bs-target="#attachmentsImages" data-bs-slide-to="' + String(i) + '"' +
                ' class="active" aria-current="true" aria-label="Slide ' + Number(i + 1) + '"> </button >';
        } else {
            x = x + '<div class="carousel-item"> ' +
                '<img src="' + images.value[i].src + '" class="d-block w-100" alt="..." />' +
                '</div>';
            y = y + '<button type = "button" data-bs-target="#attachmentsImages" data-bs-slide-to="' + String(i) + '"' +
                ' aria-label="Slide ' + Number(i + 1) + '"> </button >';
        }

    }
    document.getElementById("demo2").innerHTML = y;
    document.getElementById("demo3").innerHTML = x;

}


async function onApprove(item) {
    swal({
        title: "ตรวจสอบรายการ",
        text: "คุณต้องการอนุมัติรายการนี้",
        icon: "info",
        allowOutsideClick: false,
        showCloseButton: false,
        showCancelButton: true,
        closeOnConfirm: false,
        focusConfirm: false,
        animation: "slide-from-top",
        confirmButtonText: t('buttons.conf'),
        cancelButtonText: t('buttons.canc'),
    }).then((result) => {
        if (result.isConfirmed) {
            if (item.uid !== '') {
                approveTk(item)
            }
        }
    });
}


async function getCurrent() {
    listcur.value = []
    let data = "";
    data = {
        year: formatyear(new Date().getFullYear()),
        shopUid: shopcur_search.value,
    };
    const payload = data;
    // console.log("getCurrent p : " + JSON.stringify(payload));
    const response = await storevol.currentFetch(payload);
    // console.log("getCurrent r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                if (response.data.data !== null) {
                    listcur.value.push(response.data.data)
                }
            }
        }
    }
}


async function getShopInfo(uid) {
    shop_info.value = null
    let data = "";
    data = {
        uid: uid,
    };
    const payload = data;
    const response = await storesh.shopInfoFetch(payload);
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                shop_info.value = response.data.data
                // console.log('shop_info : ' + JSON.stringify(shop_info.value));
            }
        }
    }
}


async function getCoverDetail(i, item, val) {
    // console.log("getCover i : " + JSON.stringify(i));
    // console.log("getCover it : " + JSON.stringify(item));
    loading.value = true
    listcover.value = []
    let data = "";
    data = {
        formUid: i.uid,
        shopUid: item.shopUid,
    };
    const payload = data;
    // console.log("getCurrent p : " + JSON.stringify(payload));
    const response = await storetk.getCoverFormFetch(payload);
    // console.log("getCover r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                if (response.data.data !== null) {
                    listcover.value = response.data.data.tickets
                    if (listcover.value !== null) {
                        if (val === 'cover') {
                            let obj = {
                                fromVolNo: Number(listcover.value[0].volNo),
                                toVolNo: Number(listcover.value[listcover.value.length - 1].volNo),
                                shopName: item.fullname,
                                by: i.shopUid,
                                shopUid: item.shopUid,
                            }
                            // console.log("obj r : " + JSON.stringify(obj));
                            await coverGen(obj)
                        } else if (val === 'blank') {
                            let dt = listcover.value.filter((c) => c.printNo === null);
                            if (dt.length > 0) {
                                swal("ไม่ได้ตั้งค่าการพิมพ์ใบปะหน้าตั๋ว", "", "error");
                            } else {
                                let list = []
                                for (let i = 0; i < listcover.value.length; i++) {
                                    let obj = {
                                        volNo: listcover.value[i].volNo,
                                        no: listcover.value[i].printNo,
                                    }
                                    list.push(obj)
                                }

                                await blankGen(list)
                            }

                        }
                    } else {
                        swal('Record not found', "", "error");
                    }

                }
            }
            loading.value = false
        }
    }
}


async function coverGen(item) {
    let by = ''
    let address = ''
    let on = filterShopDetail(item.by)
    if (on.length > 0) {
        if (on[0].shopOwner !== null) {
            by = on[0].shopOwner
        }
    }

    let ad = filterShopDetail(item.shopUid)
    if (ad.length > 0) {
        if (ad[0].address !== null) {
            address = ad[0].address
        }
    }


    let data = "";
    data = {
        fromVolNo: item.fromVolNo,
        toVolNo: item.toVolNo,
        shopName: item.shopName,
        by: by,
        shopInfo: address
    };
    // console.log('data : ' + JSON.stringify(data));
    const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-admin"));
    const accessToken = keya.accessToken;
    const response = await axios({
        method: 'POST',
        data: data,
        url: st.url_api + `/pawn-rpt-svc/ticket/req/cover`,
        headers: { Authorization: `Bearer ${accessToken}` },
        responseType: 'arraybuffer',
    });
    // console.log('coverGen : ' + JSON.stringify(response));
    // console.log('pdfGen : ' + JSON.stringify(response.headers.get("content-type")));
    if (response.headers.get("content-type") === 'application/pdf') {

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank').focus();
    } else {
        swal("โหลด PDF ไม่สำเร็จ", "", "error");
    }
}


async function blankGen(item) {
    // console.log('data : ' + JSON.stringify(data));
    const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-admin"));
    const accessToken = keya.accessToken;
    const response = await axios({
        method: 'POST',
        data: item,
        url: st.url_api + `/pawn-rpt-svc/ticket/blank`,
        headers: { Authorization: `Bearer ${accessToken}` },
        responseType: 'arraybuffer',
    });
    // console.log('blankGen : ' + JSON.stringify(response));
    if (response.headers.get("content-type") === 'application/pdf') {

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank').focus();
    } else {
        swal("โหลด PDF ไม่สำเร็จ", "", "error");
    }
}

</script>

<style lang="scss" scoped>
.loading-state {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
